module.exports = __webpack_public_path__ + "static/media/resham.6eaa251e.jpg";